import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { setBetStatusFilter } from "../../../redux/actions/betActions";
import { useSelector, useDispatch } from "react-redux";

const BetStatusFilter = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const betStatusFilter = useSelector((state) => state.bets.betStatusFilter);

  const options = React.useMemo(() => {
    const statusTypes = ["pending", "win", "loss"];
    const options = new Set();
    statusTypes.forEach((row) => {
      options.add(row);
    });
    return [...options.values()];
  }, []);

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        value={betStatusFilter[0].value}
        onClick={(e) => e.stopPropagation()}
        displayEmpty
        onChange={(e) => {
          dispatch(
            setBetStatusFilter(
              [
                {
                  id: "status",
                  value: e.target.value,
                },
              ] || undefined,
            ),
          );
        }}
        inputProps={{
          name: "status",
          "aria-label": "Status filter",
          id: "status-filter",
        }}
      >
        <MenuItem aria-label="All" value="">
          <em>All Bets</em>
        </MenuItem>
        {options.map((option, i) => (
          <MenuItem key={i} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BetStatusFilter;

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: 120,
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiOutlinedInput-input": {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    "& .MuiInputBase-root": {
      color: theme.palette.common.white,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.common.white,
    },
    "& .MuiSelect-icon": {
      color: theme.palette.common.white,
    },
  },
}));
